import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChipDropdownComponent } from '../../../../../shared/payee-cases/chip-dropdown/chip-dropdown.component';
import { PayeeFormFieldComponent } from '../../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';

@Component({
  selector: 'app-invoice-debtor-name-filter',
  templateUrl: './invoice-debtor-name-filter.component.html',
  styleUrls: ['./invoice-debtor-name-filter.component.scss'],
  imports: [
    ChipDropdownComponent,
    PayeeFormFieldComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class InvoiceDebtorNameFilterComponent {
  @Input({ required: true }) control!: FormControl<string | null>;

  dropdownOpen = false;

  closeAfterPaste(): void {
    setTimeout(() => (this.dropdownOpen = false));
  }
}
